"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ThemeProvider } from "next-themes";
import { useMemo } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AppConfigProvider } from "@/lib/config";
import type { AppConfig } from "@/lib/config-server";
import type { ReactNode } from "react";
interface ProvidersProps {
  children: ReactNode;
  config: AppConfig;
}
export function Providers(t0) {
  const $ = _c(10);
  const {
    children,
    config
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          staleTime: 300000,
          retry: false
        }
      }
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = process.env.NODE_ENV === "development" && <ReactQueryDevtools buttonPosition="bottom-right" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <QueryClientProvider client={queryClient}>{children}{t2}</QueryClientProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Toaster />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <ThemeProvider attribute="class" defaultTheme="system" enableSystem={true} storageKey="theme">{t3}{t4}</ThemeProvider>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== config || $[8] !== t5) {
    t6 = <AppConfigProvider config={config}>{t5}</AppConfigProvider>;
    $[7] = config;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}